import { ValueOf } from 'ts-essentials';

import type { FlattenedField } from 'payload';

export const EXPORT_METHODS = {
  GOOGLE_SHEET: 'google-sheet',
} as const;

export const IMPORT_METHODS = {
  FROM_EXPORT: 'from-export',
} as const;

export type ExportMethod = ValueOf<typeof EXPORT_METHODS>;
export type ImportMethod = ValueOf<typeof IMPORT_METHODS>;

export const EXPORTABLE_FIELD_TYPES: FlattenedField['type'][] = ['text', 'textarea', 'number', 'richText'];

export const SYSTEM_FIELD_NAMES = new Set<string>(['id', 'blockName']);
